import React, { useEffect, useState } from "react";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { CustomerPaymentColumns } from "../../../assets/Columns/CustomerPaymentColumns";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Header from "../../../components/Header/Header";
import { fetchCompanyPayments } from "../../../store/Slices/CompanyPaymentSlice";
import { CompanyPaymentColumns } from "../../../assets/Columns/CompanyPaymentColumns";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { DeleteSupplierPaymentApi } from "../../../ApiRequests";
import { ErrorToast, SuccessToast } from "../../../utils/ShowToast";

const CompanyPayments = () => {
  const { id } = useParams();
  const [SearchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState("");
  const [Loading, setLoading] = useState(false);

  const CompanyPayments = useSelector((state) => state.CompanyPayments);

  useEffect(() => {
    dispatch(fetchCompanyPayments(id));
  }, []);

  return (
    <div className="w-full flex flex-col px-4 pt-2 pb-8 gap-y-8">
      <Header
        title="Company-Payments"
        desc="Manage your payments efficiently"
      />
      {CompanyPayments.data && (
        <SearchableTable
          setOpenEditModal={setOpenEditModal}
          setOpenDeleteModal={setOpenDeleteModal}
          setSelected={setSelected}
          SearchPlaceholder={"Search Invoice #..."}
          SearchText={SearchText}
          setSearchText={setSearchText}
          CurrentData={CompanyPayments.data}
          Columns={CompanyPaymentColumns}
        />
      )}

      {OpenDeleteModal && (
        <DeleteModal
          Open={OpenDeleteModal}
          setOpen={setOpenDeleteModal}
          Loading={Loading}
          onSubmit={async () => {
            setLoading(true);
            try {
              const response = await DeleteSupplierPaymentApi(Selected._id);
              if (response.data.success) {
                setOpenDeleteModal(false);
                SuccessToast("Company Payment delete successfully");
                dispatch(dispatch(fetchCompanyPayments(id)));
              } else {
                ErrorToast(response.data.error?.msg);
              }
            } catch (err) {
              ErrorToast(
                err.response.data.error.msg || "Failed to delete customer!"
              );
            }
            setLoading(false);
          }}
        />
      )}
    </div>
  );
};

export default CompanyPayments;
